import React from "react";
import Form from "react-bootstrap/lib/Form";

export const Input = ({
  fieldId,
  fieldName,
  isActive,
  errors,
  values,
  isRequired,
  fieldType,
  handleChange,
  handleBlur,
}) => (
  <Form.Group>
    <div className="field field--input">
      <Form.Label htmlFor={`terytStreet`} className="field__label">
        {isRequired ? `${fieldName}*` : fieldName}
      </Form.Label>
      <Form.Control
        disabled={!isActive}
        id={fieldId}
        name={fieldId}
        type={fieldType}
        value={values[fieldId]}
        onChange={handleChange}
        onBlur={handleBlur}
        className="field__input"
        isInvalid={!!errors[fieldId]}
        autocomplete="off"
        placeholder={fieldName}
      />
    </div>
    <Form.Control.Feedback type="invalid" className="field--invalid d-flex">
      {errors[fieldId]}
    </Form.Control.Feedback>
  </Form.Group>
);
